var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "enkai__faq__container" }, [
    _c("h2", { staticClass: "enkai__faq__heading" }, [
      _vm._v(_vm._s(_vm.prefectureName) + "の会場探しでよくある質問"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "enkai__faq__content" },
      [
        _c("h3", { staticClass: "enkai__faq__question" }, [
          _vm._v(
            _vm._s(_vm.prefectureName) +
              "で宴会・パーティーの貸切予約におすすめの会場はどこですか？"
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "enkai__faq__answer" },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.prefectureName) +
                "にはグルメプラスおすすめのレストランが" +
                _vm._s(_vm.shopsCount) +
                "件あり、その中でも宴会・パーティーの貸切予約におすすめのレストランは、"
            ),
            _vm._l(_vm.recommendedShops, function (shop, index) {
              return _c("span", { key: "recommendedShops" + shop.id }, [
                _c("a", { attrs: { href: `${shop.detail_url}` } }, [
                  _vm._v(_vm._s(shop.name)),
                ]),
                index < _vm.recommendedShops.length - 1
                  ? _c("span", [_vm._v("、")])
                  : _vm._e(),
              ])
            }),
            _vm._v("などがあります。"),
            _c("br"),
            _vm._v(
              "\n      " +
                _vm._s(_vm.prefectureName) +
                "で宴会・パーティー会場の貸切予約を行う場合は、"
            ),
            _vm._l(_vm.recommendedAreas, function (area, index) {
              return _c("span", { key: area.id }, [
                _c("a", { attrs: { href: `./A${area.id}/` } }, [
                  _vm._v(_vm._s(area.name)),
                ]),
                index < _vm.recommendedAreas.length - 1
                  ? _c("span", [_vm._v("や")])
                  : _vm._e(),
              ])
            }),
            _vm._v(
              "などの人気エリアから探しつつ、交通アクセスの良い場所を選択するのがおすすめです。\n    "
            ),
          ],
          2
        ),
        _vm._v(" "),
        this.recommendedMaxCapacityShops.length > 0
          ? [
              _c("h3", { staticClass: "enkai__faq__question" }, [
                _vm._v(
                  _vm._s(_vm.prefectureName) +
                    "で大人数の貸切予約におすすめのパーティー会場はありますか？"
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "enkai__faq__answer" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.prefectureName) +
                      "で大人数の貸切予約におすすめの宴会場は、"
                  ),
                  _vm._l(
                    _vm.recommendedMaxCapacityShops,
                    function (shop, index) {
                      return _c(
                        "span",
                        { key: "recommendedMaxCapacityShops" + shop.id },
                        [
                          _c("a", { attrs: { href: `${shop.detail_url}` } }, [
                            _vm._v(_vm._s(shop.name)),
                          ]),
                          index < _vm.recommendedMaxCapacityShops.length - 1
                            ? _c("span", [_vm._v("、")])
                            : _vm._e(),
                        ]
                      )
                    }
                  ),
                  _vm._v("などがあります。"),
                  _c("br"),
                  _vm._v(" "),
                  _vm._l(
                    _vm.recommendedMaxCapacityShops,
                    function (shop, index) {
                      return _c(
                        "span",
                        { key: "recommendedMaxCapacityShopsDetail" + shop.id },
                        [
                          _c("a", { attrs: { href: `${shop.detail_url}` } }, [
                            _vm._v(_vm._s(shop.name)),
                          ]),
                          _vm._v(
                            "は最大" +
                              _vm._s(
                                shop.maxCapacity > 0 ? shop.maxCapacity : "--"
                              ) +
                              "人"
                          ),
                          index < _vm.recommendedMaxCapacityShops.length - 1
                            ? _c("span", [_vm._v("、")])
                            : _vm._e(),
                        ]
                      )
                    }
                  ),
                  _vm._v(
                    "での貸切予約が可能であり、" +
                      _vm._s(_vm.prefectureName) +
                      "で大人数の宴会やパーティーを行う際におすすめです。\n      "
                  ),
                ],
                2
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }